module.exports = __webpack_public_path__ + "img/TractionLinux.e0485b16.png";